import { useSyncExternalStore } from 'react';

const phoneQuery = '(max-width: 720px)';
function subscribe(update: () => void) {
  const media = window.matchMedia?.(phoneQuery);
  media?.addEventListener('change', update);
  return () => media?.removeEventListener('change', update);
}
export function usePhoneLayout() {
  return useSyncExternalStore(subscribe, () => window.matchMedia?.(phoneQuery).matches ?? false, () => false);
}
